export const enum CardButtonTypes {
  selection = 'selection',
  simple = 'simple',
  extras = 'extras',
  gift = 'gift',
}
